import Component from '../vendor/Component'

export default class ContentGridCarousel extends Component {
  mount() {
    this.slidesContainer = this._elem.querySelector('[data-slides]')
    this.slideElements = this._elem.querySelectorAll('[data-slide]')

    if (!this.slidesContainer || this.slideElements.length < 2) return

    this.setupCarousel()
    this.updateArrowPosition()
    this._resizeListener = () => this.updateArrowPosition()
    window.addEventListener('resize', this._resizeListener)
  }

  unmount() {
    if (this._resizeListener) {
      window.removeEventListener('resize', this._resizeListener)
    }
  }

  updateArrowPosition() {
    const firstSlide = this._elem?.querySelector('.swiper-slide')
    const media = firstSlide?.querySelector('.sec-ContentGrid_Media')
    if (!media || !this._elem) return

    const containerRect = this._elem.getBoundingClientRect()
    const mediaRect = media.getBoundingClientRect()
    const arrowTop = (mediaRect.top - containerRect.top) + mediaRect.height / 2
    this._elem.style.setProperty('--content-grid-arrow-top', `${arrowTop}px`)
  }

  setupCarousel() {
    if (!window.swiper) return

    this.carousel = new window.swiper(this.slidesContainer, {
      direction: 'horizontal',
      loop: false,
      initialSlide: 0,
      slidesPerView: 1.03,
      spaceBetween: 5,
      slidesPerGroup: 1,
      centeredSlides: false,
      centeredSlidesBounds: false,
      speed: 500,
      navigation: {
        nextEl: this._elem.querySelector('[data-next]'),
        prevEl: this._elem.querySelector('[data-prev]')
      },
      breakpoints: {
        451: {
          slidesPerView: 1.03
        },
        768: {
          slidesPerView: 3.2
        },
        1200: {
          slidesPerView: 3.2
        }
      },
      on: {
        init: () => {
          requestAnimationFrame(() => this.updateArrowPosition())
        }
      }
    })
  }
}
